import { TooltipArrow, TooltipContent } from 'base/src/components/Tooltip';
import styled from 'styled-components';

export interface SubtitleProps {
  blue?: boolean;
  red?: boolean;
  bold?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.75rem, 1.5vw, 1.25rem);
  height: 10%;
  justify-content: space-between;
`;

export const TextConainer = styled.div`  
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: clamp(0.75rem, 1.5vw, 1.25rem);
  width: 100%;
`;

export const SubtitleConainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const InfoLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.25rem, 0.5vw, 0.375rem);
`;

export const InfoRight = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.25rem, 0.5vw, 0.375rem);
`;

export const Title = styled.span`
  font-size: clamp(0.875rem, 1.2vw, 0.9375rem);
  font-weight: 700;
  color: ${props => props.theme.colors.text};
  margin-bottom: clamp(0.25rem, 0.5vw, 0.3125rem);
  transition: 200ms;
`;

export const Subtitle = styled.span<SubtitleProps>`
  font-size: clamp(0.75rem, 1vw, 0.875rem);
  color: ${props => props.theme.colors.grey_text};
  font-weight: ${({ bold }) => (bold ? '700' : '0')};
  
  ${({ blue }) => blue && `
    color: #2897FF;
  `}

  ${({ red }) => red && `
    color: #d03232;
  `}

  transition: 200ms;
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
`;

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.5rem, 1vw, 0.625rem);
`;

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const WarningContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-end;
  gap: clamp(0.25rem, 0.5vw, 0.375rem);
  margin-top: clamp(0.5rem, 1vw, 0.625rem);
  
  @media (max-width: 576px) {
    align-self: flex-start;
  }
`;

export const WarningText = styled.span`
  color: ${props => props.theme.colors.negative};
  font-weight: 700;
  font-size: clamp(0.75rem, 1vw, 0.875rem);
`;

export const TooltipContentStyled = styled(TooltipContent)`
  background-color: #FF7373;
  color: ${props => props.theme.colors.white};
  padding: clamp(0.375rem, 0.75vw, 0.5rem);
  font-size: clamp(0.75rem, 1vw, 0.875rem);
`;

export const TooltipArrowStyled = styled(TooltipArrow)`
  fill: #FF7373;
`;



